import React from "react";
import { usePowder } from "../redux/ReduxContext";



export default function OiPowderComment() {
    const { state, dispatch } = usePowder();
    return (
        <div className="bg-white dark:bg-oi-dark-background p-4  drop-shadow-md mb-4">
            <h6 className="mb-2 text-sm font-bold">Comment</h6>

            <textarea
                className="resize-y border  w-full p-2 mt-2 pt-3
             text-sm focus:outline-none focus:ring-2 
             bg-primary-light dark:bg-primary-dark 
             border-gray-300 dark:border-gray-600 
             placeholder-gray-400 min-h-12 overflow-hidden"
                placeholder="Add additional comments here..."
                rows={1}
                value={state.comment}
                onChange={(e) => {
                    dispatch({ type: 'SET_FIELD', payload: { field: 'comment', value: e.target.value } });
                    e.target.style.height = "auto";
                    e.target.style.height = `${e.target.scrollHeight}px`;
                }}
            />
        </div>
    );
};
